export default __webpack_public_path__ + "static/media/lions_logo.f882c672.png";